import HttpService from "../../../services/HttpService";

export const fetchCourseDetails = async (courseId) => {
  const role = (localStorage.getItem("userRole") || "").toLowerCase();
  const isSuperAdmin = role === "superadmin";

  if (isSuperAdmin) {
    return HttpService.get(`/club/golf-course-details-admin/${courseId}`);
  } else {
    return HttpService.get(`/club/course_details/${courseId}/`);
  }
};
export const fetchScoreCardDetails = (body) => HttpService.post(`/game/score/`, body)

export const getCourseList = () => {
  const role = (localStorage.getItem("userRole") || "").toLowerCase();
  const isSuperAdmin = role === "superadmin";

  if (isSuperAdmin) {
    const clubId = localStorage.getItem("selected_club_id");
    return HttpService.get(`/club/golfclub/${clubId}/courses/`);
  }

  return HttpService.get(`/club/my_courses/`);
};
export const fetchPlayersLive = (courseId) => HttpService.get(`/user/location_by_course/${courseId}/`, {
    cancelToken: false
})

export const sendPlayerAlert = (data) => HttpService.post(`/user/send_alert/`, data);

export const resetPlayerData = (data) => HttpService.post(`/game/reset_player/`, data);
